import { render } from "./PVHistoricProductionComponent.vue?vue&type=template&id=68fefd66&scoped=true&ts=true"
import script from "./PVHistoricProductionComponent.vue?vue&type=script&lang=ts"
export * from "./PVHistoricProductionComponent.vue?vue&type=script&lang=ts"

import "./PVHistoricProductionComponent.vue?vue&type=style&index=0&id=68fefd66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fefd66"]])

export default __exports__